"use strict";

var moment = require('moment');

var getValueOfKeyMatching = require('./applyComponentProperties/getValueOfKeyMatching');

var parseDesignName = require('./parseDesignName');

function applyPersonalization(params, instance) {
  var design_name = parseDesignName(params, instance.designStyles());
  this.design_name = design_name;
  this.paper_type = getValueOfKeyMatching(params, /paper_options/); // people can put more than an email address in this field
  // so let's parse out the email if we can

  if (params.pers_reprintEmail) {
    var matchers = params.pers_reprintEmail.match(/(.*@.*)/);

    if (matchers && matchers[1]) {
      this.contact_email = matchers[1];
    } else {
      this.contact_email = params.pers_reprintEmail;
    }

    if (params.product_type.match(/reprint/i)) {
      this.personalization.push({
        name: 'Previous Order Details',
        value: params.pers_reprintEmail
      });
    }
  }

  if (params.contact_email) {
    var _matchers = params.contact_email.match(/(.*@.*)/);

    if (_matchers && _matchers[1]) {
      this.contact_email = _matchers[1];
    } else {
      this.contact_email = params.contact_email;
    }
  }

  if (params.event_date) {
    this.event_date = moment(params.event_date, 'MM/DD/YYYY');
  }

  if (params['color-grid-pers']) {
    if (params.product_type.match(/letterpress/i)) {
      this.letterpress_ink_colors = params['color-grid-pers'].split(', ').map(function (c) {
        if (c === 'Black') {
          return 'Soft Black';
        }

        return c;
      });
    } else {
      this.ink_colors = params['color-grid-pers'].split(', ').map(function (c) {
        if (c === 'Soft Black') {
          return 'Black';
        }

        return c;
      });
    }
  } // reserved signs have this special field


  if (params.signs_color) {
    this.ink_colors = [params.signs_color];
  } // table numbers have this special field


  if (params.tableColor) {
    this.ink_colors = [params.tableColor];
  }

  if (params.pers_color) {
    this.color_notes = params.pers_color;
  }

  if (params.pers_notes) {
    this.customer_notes = params.pers_notes;
  }

  if (params.file_display_name) {
    this.file_display_name = params.file_display_name;
  }

  if (params.file_server_name) {
    this.file_server_name = params.file_server_name;
  }
}

module.exports = applyPersonalization;